module.exports = __webpack_public_path__ + "img/1504045094.d962bc4d.jpg";